export interface GlobalHomeTrackingEnumConfig {
    name?: string;
    _from?: string;
    _package?: string;
}

export enum GlobalHomeTrackingEvent {
    GLOBAL_HOME_VIEW_PAGE = 'GLOBAL_HOME_VIEW_PAGE',
    GLOBAL_HOME_ITEM_CLICKED = 'GLOBAL_HOME_ITEM_CLICKED',
}

export const GlobalHomeTrackingEnums: { [event in GlobalHomeTrackingEvent]: GlobalHomeTrackingEnumConfig } = {
    [GlobalHomeTrackingEvent.GLOBAL_HOME_VIEW_PAGE]: {
        name: 'Global Home - View Page',
    },
    [GlobalHomeTrackingEvent.GLOBAL_HOME_ITEM_CLICKED]: {},
};
